S.jumpmarkContact = {
    elements: {
        $contact: null,
    },

    config: {
        isSticky: false,
    },

    $curInst: null,

    init()
    {


        this.$curInst = this.instances[this.instance];
        const offsetTop = -$('.mod-header').eq(0).height();

        if (this.$curInst.config.isSticky)
        {
            // check visibility of sticky jumpmark
            this.checkVisibility();
            $(window).on('scroll', () =>
            {
                S.delayed('jumpmarkContact', 100, () => {
                    this.checkVisibility();
                });
            });
        }

        // scroll down to contact
        this.elements.$contact.on('click', () =>
        {
            $('html, body').animate(
                {
                    scrollTop: $('.mod-contact').eq(0).offset().top + offsetTop,
                }, 500);

            if (this.$curInst.config.isSticky)
            {
                this.elements.$contact.hide();
            }
        });
    },

    isElementInViewport(el)
    {
        const rect = el[0].getBoundingClientRect();

        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= ($(window).innerHeight() || $(window).height()) &&
            rect.left <= ($(window).innerWidth() || $(window).width())
        );
    },

    checkVisibility()
    {
        // if footer is visible, hide sticky contact
        if (this.isElementInViewport($('.mod-contact').eq(0)))
        {
            this.elements.$contact.hide();
        }
        else
        {
            this.elements.$contact.show();
        }
    },
};
